import * as React from 'react';
import { colors } from '../../../index';

const IconBlock = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 11 12",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5.5A5.498 5.498 0 000 6c0 3.039 2.461 5.5 5.5 5.5S11 9.039 11 6 8.539.5 5.5.5zM1.1 6c0-2.431 1.969-4.4 4.4-4.4 1.018 0 1.95.35 2.695.927L2.027 8.695A4.384 4.384 0 011.1 6zm4.4 4.4c-1.018 0-1.95-.35-2.695-.927l6.168-6.168C9.551 4.05 9.9 4.983 9.9 6c0 2.431-1.969 4.4-4.4 4.4z",
    fill: "currentColor"
  }));
};

export default IconBlock;